import InviraRolesPermissions from './InviraRolesPermissions.vue'

export default InviraRolesPermissions

